<template>
  <div :class="[{ 'md:pt-[115px]': checkView.post }]">
    <div
      v-if="author"
      :key="author.slug"
      :style="
        checkView.post && scrollPosition < 40 && windowWidth >= 768
          ? `transform: translateY(-${scrollPosition}px)`
          : undefined
      "
      :class="[
        'w-full transition-shadow',
        {
          'md:fixed left-0 right-0 z-30': checkView.post,
          'md:top-[106px] shadow-pt': checkView.post && scrollPosition >= 40,
          'top-36': checkView.post && scrollPosition < 40,
          'md:absolute':
            checkView.post && scrollPosition < 40 && !(scrollPosition && windowWidth >= 768)
        }
      ]"
    >
      <Section
        v-if="blogData.authors.length > 1 && checkView.blog"
        grid="E"
        overlay="hided"
        height="100%"
        bg-hero="/headerGradient.svg"
        padding-y="pt-6 md:pt-10"
      >
        <template #header>
          <Breadcrumbs
            :path="COMMUNITY_BASE_URL"
            color="white"
            class="container mb-8"
            :data="breadcrumbsData"
            :section="$t('breadcrumbs.community')"
          />
        </template>
        <template #content>
          <Community :people="blogData.authors" mode-community title-hided divisor-hided />
        </template>
      </Section>
      <Section
        v-else
        :key="`personal-information-${author.id}`"
        overlay="hided"
        height="100%"
        bg-hero="/headerGradient.svg"
        :padding-y="`py-6 ${checkView.blog ? 'md:py-12' : 'md:py-3'}`"
      >
        <template #content-left>
          <div
            :class="
              checkView.post
                ? 'flex items-center'
                : 'border-b sm:border-b-0 pb-5 sm:pb-0 sm:pr-5 sm:-mr-2.5 sm:border-r border-gray'
            "
          >
            <Breadcrumbs
              v-if="checkView.blog"
              :path="COMMUNITY_BASE_URL"
              class="mb-4"
              color="white"
              :data="breadcrumbsData"
              :show-category="false"
              :section="$t('breadcrumbs.community')"
            />
            <component
              :is="checkView.blog ? 'h1' : NuxtLink"
              v-if="blogData.name"
              :to="checkView.blog ? undefined : `${COMMUNITY_BASE_URL}/${blogData.blog?.slug}`"
              :class="[
                'font-ubuntu text-white',
                checkView.blog
                  ? 'mb-4 text-[40px] leading-[50px] font-bold'
                  : 'text-3xl font-medium'
              ]"
            >
              {{ blogData.name }}
            </component>
            <p v-if="blogData.description" class="flex leading-5.5 font-medium text-white">
              {{ blogData.description }}
            </p>
          </div>
        </template>
        <template #content-right>
          <div
            :class="[
              'relative flex overflow-hidden',
              checkView.post ? 'sm:justify-end' : 'pt-5 sm:pt-0 sm:pl-5'
            ]"
          >
            <component
              :is="author?.slug && author?.vip ? NuxtLink : 'div'"
              :to="author.slug ? `${AUTHOR_BASE_URL}/${author.slug}` : undefined"
              :class="[
                'flex items-center hover:decoration-white',
                checkView.blog ? 'flex-wrap -m-2.5' : 'sm:max-w-sm'
              ]"
            >
              <div class="flex-none m-2.5">
                <NuxtImg
                  v-if="author.image?.url"
                  :class="['rounded-full', checkView.blog ? 'w-20 h-20' : 'w-16 h-16']"
                  :src="author.image.url"
                  :alt="author.alternativeText || 'blog author'"
                  loading="lazy"
                />
              </div>
              <div class="m-2.5">
                <span
                  v-if="author.name"
                  :class="[
                    'block font-ubuntu text-white',
                    checkView.blog ? 'mb-2.5 text-2xl font-bold' : 'mb-1.5 text-lg font-medium'
                  ]"
                  v-text="author.name"
                />
                <span
                  v-if="author.job"
                  :class="[
                    'block text-white',
                    checkView.blog ? 'text-lg' : ' text-sm line-clamp-3'
                  ]"
                  v-text="author.job"
                />
              </div>
            </component>
          </div>
        </template>
      </Section>
    </div>
  </div>
</template>

<script>
import Section from '@/components/Sections';
import Community from '@/components/Community';
import Breadcrumbs from '~/components/Breadcrumbs';
import { COMMUNITY_BASE_URL, AUTHOR_BASE_URL } from '~/utils/enums';
export default {
  components: {
    Breadcrumbs,
    Section,
    Community
  },
  props: {
    blogData: {
      type: Object,
      default: () => {}
    }
  },
  setup() {
    const { windowWidth, scrollPosition } = useWindow();
    return { NuxtLink: resolveComponent('NuxtLink'), windowWidth, scrollPosition };
  },
  data() {
    return {
      AUTHOR_BASE_URL,
      COMMUNITY_BASE_URL
    };
  },
  computed: {
    author() {
      return Array.isArray(this.blogData.authors) && this.blogData.authors.length
        ? this.blogData.authors[0]
        : undefined;
    },
    checkView() {
      const blogView = this.$route.params.blog;
      const postView = this.$route.params.slug;
      return {
        blog: blogView != null && postView == null,
        post: blogView != null && postView != null
      };
    },
    breadcrumbsData() {
      return this.$route.params.blog
        ? {
            label: this.blogData?.name ?? this.blogData?.blog?.name ?? '',
            slug: `${COMMUNITY_BASE_URL}/${this.$route.params.blog}`
          }
        : (this.blogData?.name ?? this.blogData?.blog?.name ?? '');
    }
  }
};
</script>
